export function alignCenter(test: SVGElement, t: String, x: number) {
	test.innerHTML = t as string
	const size = (test.firstElementChild as SVGTextElement).getBBox()
	return t.replace('<text', `<text x="${x - size.width / 2}"`)
}
